/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type { ChangeCalendarLayout as ChangeCalendarType } from '@jira/spa-apps__servicedesk-change-calendar/src/ChangeCalendarLayout.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyChangeCalendar: LazyComponent<() => React.JSX.Element | null> = lazyForPaint<
	typeof ChangeCalendarType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-change-calendar", jiraSpaEntry: "async-servicedesk-change-calendar" */ '@jira/spa-apps__servicedesk-change-calendar/src/ServicedeskChangeCalendar.tsx'
		),
	),
);

const AsyncChangeCalendar = (): React.JSX.Element => (
	<LazyPage
		Page={LazyChangeCalendar}
		pageId="spa-apps/servicedesk/change-calendar"
		shouldShowSpinner
	/>
);

export default AsyncChangeCalendar;
